
export default class ClassroomMenu {
    readonly kbn: string
    readonly name: string
    readonly viewName: string
    readonly visibility: boolean

    constructor(data: { [key: string]: any }) {
        this.kbn = data.kbn
        this.name = data.name
        this.viewName = data.viewName
        this.visibility = data.visibility == "true"
    }
}
